import { AnyAction } from 'redux';
import * as constants from 'redux/constants/matzeva.constants';
import { ITableUpdate } from 'types/table.types';
import { IMatzevaFormData } from 'views/public/MatzevaView/components/MatzevaForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.MATZEVA_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.MATZEVA_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.MATZEVA_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.MATZEVA_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IMatzevaFormData, id?: string): AnyAction => ({
  type: constants.MATZEVA_ON_SAVE_REQUESTED,
  formData,
  id,
});
